import { useEffect, useState } from 'react'

// Mirrors the original nav script:
// - dark theme while within the first 100px, light theme (with white background) after
// - hides the moment the scroll direction turns downward, returns the moment it turns upward
export function useNavState() {
  const [scrolled, setScrolled] = useState(false)
  const [hidden, setHidden] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    let lastY = window.scrollY
    let direction: 'up' | 'down' | null = null
    const onScroll = () => {
      const y = Math.max(0, window.scrollY)
      setScrolled(y >= 100)
      if (y === lastY) return
      const next = y > lastY ? 'down' : 'up'
      if (next !== direction) {
        direction = next
        setHidden(next === 'down')
      }
      lastY = y
    }
    setScrolled(window.scrollY >= 100)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''
    if (!menuOpen) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [menuOpen])

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 992) setMenuOpen(false)
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return { scrolled, hidden, menuOpen, setMenuOpen }
}
